import { useMemo } from 'react';
import { useAIFeatureFlags } from './useAIFeatureFlags';

export const useAIFeatureAvailability = () => {
  const {
    isVinReelsEnabled,
    isQuickVideosEnabled,
    isAISpotlightEnabled,
    isAIAssistantEnabled,
  } = useAIFeatureFlags();

  return useMemo(() => {
    // Pronunciation
    const isPronunciationAvailable =
      isAIAssistantEnabled || isVinReelsEnabled || isAISpotlightEnabled;

    // Dealership Highlights
    const isDealershipHighlightsAvailable =
      isVinReelsEnabled || isQuickVideosEnabled;

    // Personalization
    const isPersonalizationAvailable =
      isPronunciationAvailable || isDealershipHighlightsAvailable;

    // AI Assistants
    const isAIAssistantsAvailable =
      isAISpotlightEnabled || isAIAssistantEnabled;

    // Quick Videos
    const isQuickVideosAvailable = isQuickVideosEnabled;

    // Vin Reels
    const isVinReelsAvailable = isVinReelsEnabled;

    // Configuration
    const isAIConfigurationAvailable =
      isPersonalizationAvailable ||
      isAIAssistantsAvailable ||
      isQuickVideosAvailable;

    return {
      isPronunciationAvailable,
      isDealershipHighlightsAvailable,
      isPersonalizationAvailable,
      isAIAssistantsAvailable,
      isQuickVideosAvailable,
      isVinReelsAvailable,
      isAIConfigurationAvailable,
    };
  }, [
    isVinReelsEnabled,
    isQuickVideosEnabled,
    isAISpotlightEnabled,
    isAIAssistantEnabled,
  ]);
};
